import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";

/**
 * A route guard component that redirects unauthenticated users to the sign-in page.
 * Wrap any admin/protected route with this component.
 *
 * Usage:
 *   <ProtectedRoute><AdminDashboard /></ProtectedRoute>
 */
const ProtectedRoute = ({ children }) => {
    const { isSignedIn, isLoaded } = useUser();

    // Show nothing while Clerk is still loading auth state
    if (!isLoaded) {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                fontSize: "1.2rem",
                color: "#666"
            }}>
                Loading...
            </div>
        );
    }

    // Redirect to sign-in if not authenticated
    if (!isSignedIn) {
        return <Navigate to="/SignIn" replace />;
    }

    return children;
};

export default ProtectedRoute;
